import React from "react";
import { Colors } from "../../../utils/colors";
import { TCText } from "../../TCText/TCText";

type props = {};

export const ComingSoonBar: React.FC<props> = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        position: "relative",
        flexDirection: "row",
        gap: 7,
        marginBottom: 10,
      }}>
      <div
        style={{
          height: 2,
          backgroundColor: Colors.lightGreyBackground,
          flex: 1,
        }}
      />
      <TCText
        style={{ fontWeight: 500, fontSize: 10, color: Colors.darkBrown }}
        value="Coming soon"
      />
      <div
        style={{
          height: 2,
          backgroundColor: Colors.lightGreyBackground,
          flex: 1,
        }}
      />
    </div>
  );
};
